import {
  Fade,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { PaymentTermBrief } from '../../types/walletPaymentTerm'
import PaymentTermRow from './PaymentTermRow'
import TanantRowSkeleton from './PaymentTermRow.skeleton'
import useStyles from './styles/PaymentTermTable.styles'

interface PaymentTermTableProps {
  paymentTerms: PaymentTermBrief[]
  loading: boolean
  refetch: () => void
}

const PaymentTermTable: React.FC<PaymentTermTableProps> = ({
  paymentTerms,
  loading,
  refetch
}) => {
  const theme = useTheme()
  const classes = useStyles()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">
            {getTranslate(`${isSmallScreen ? '' : 'Payment Term '}Name`)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate(`${isSmallScreen ? '' : 'Payment Term '}Code`)}
          </Typography>
        </div>
        <div>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map(() => <TanantRowSkeleton />)
        : paymentTerms.map((item) => (
            <Fade in timeout={600} key={item.paymentTermID}>
              <PaymentTermRow data={item} />
            </Fade>
          ))}
    </div>
  )
}
export default PaymentTermTable
